import { configure } from 'mobx';

import AccountStore from './accountStore';
import UIState from './uiState';
import HomeStore from './homeStore';
import CustomeManagementStore from './customerManagementStore'
import CustomerMasterDataStore from './customerMasterDataStore'
import PermissionManagementStore from './permissionManagementStore'
import UserManagementStore from './userManagementStore'
import RoleManagementStore from './roleManagementStore'
import ApprovePermissionStore from './approvePermissionStore'
import ApplyStore from './applyStore'
import MappingManagementStore from './mappingManagementStore'
import ApiManagementStore from './apiManagementStore'
import ConnectionMonitorStore from './connectionMonitorStore'
import MessageManagementStore from './messageManagementStore'
import MessageDetailStore from './messageDetailStore'
import ApiToolsStore from './apiToolsStore'
import StreamManagementStore from './streamManagementStore'
import JobManagementStore from './jobManagementStore'
import IndexManagementStore from './indexManagementStore'
import ReportStore from './reportStore'
import WebEDIShipToStore from './webEDIShipToStore'
import WebEDIStore from './webEDIStore'
import UserEmailManagementStore from './userEmailManagementStore'
import RulesManagementStore from './rulesManagementStore'
import EmailManagementStore from './emailManagementStore'
import ReportManagementStore from './reportManagementStore'
import AuditLogsStore from './auditLogsStore'
import RouterStateModel from './routerStateModel'
import DataFlowMonitoringConfigStore from './dataFlowMonitoringConfigStore'
import DataFlowLogStore from './dataFlowLogStore'
import MarketingManagementStore from './marketingManagementStore'
import MarketingSmsSignatureStore from './marketingSmsSignatureStore'
import MarketingSmsTemplateStore from './marketingSmsTemplateStore'
import MarketingShortLinkStore from './marketingShortLinkStore'
import MarketingSmsManagementStore from './marketingSmsManagementStore'
import MarketingSmsManagementDetailsStore from './marketingSmsManagementDetailsStore'
import EmailAddressStore from './emailAddressStore'
import EmailTemplateStore from './emailTemplateStore'
import EmailListStore from './emailListStore'
import MarketingResourcePoolStore from './marketingResourcePoolStore'
import MiceCadStore from './miceCadStore'
import FatigueConfigStore from './fatigueConfigStore'
import RemarkTemplateListStore from './remarkTemplateListStore'
import ManualOutboundCallStore from './manualOutboundCallStore'
import IntelligentOutboundCallModelStore from './intelligentOutboundCallModelStore'
import IntelligentOutboundCallStore from './intelligentOutboundCallStore'
import IntelligentOutboundCallDetailsStore from './intelligentOutboundCallDetailsStore'
import ThemeSettingStore from './themeSettingStore'
import IntelligentQueryStore from './intelligentQueryStore'
import ReportTagStore from './reportTagStore'

configure({ enforceActions: 'observed' });

export default class RootStore {
  constructor() {
    this.accountStore = new AccountStore(this)
    this.uiState = new UIState(this)
    this.homeStore = new HomeStore(this)
    this.userManagementStore = new UserManagementStore(this)
    this.roleManagementStore = new RoleManagementStore(this)
    this.applyStore = new ApplyStore(this)
    this.approvePermissionStore = new ApprovePermissionStore(this)
    this.permissionManagementStore = new PermissionManagementStore(this)
    this.customerManagementStore = new CustomeManagementStore(this)
    this.customerMasterDataStore = new CustomerMasterDataStore(this)
    this.mappingManagementStore = new MappingManagementStore(this)
    this.apiManagementStore = new ApiManagementStore(this)
    this.connectionMonitorStore = new ConnectionMonitorStore(this)
    this.messageManagementStore = new MessageManagementStore(this)
		this.messageDetailStore = new MessageDetailStore(this)
		this.apiToolsStore = new ApiToolsStore(this)
		this.streamManagementStore = new StreamManagementStore(this)
		this.jobManagementStore = new JobManagementStore(this)
		this.indexManagementStore = new IndexManagementStore(this)
		this.reportStore = new ReportStore(this)
		this.webEDIShipToStore = new WebEDIShipToStore(this)
		this.webEDIStore = new WebEDIStore(this)
		this.userEmailManagementStore = new UserEmailManagementStore(this)
		this.rulesManagementStore = new RulesManagementStore(this)
		this.emailManagementStore = new EmailManagementStore(this)
		this.reportManagementStore = new ReportManagementStore(this)
		this.auditLogsStore = new AuditLogsStore(this)
    this.routerStateModel = new RouterStateModel(this)
    this.dataFlowMonitoringConfigStore = new DataFlowMonitoringConfigStore(this)
    this.dataFlowLogStore = new DataFlowLogStore(this)
    this.marketingManagementStore = new MarketingManagementStore(this)
    this.marketingSmsSignatureStore = new MarketingSmsSignatureStore(this)
    this.marketingSmsTemplateStore = new MarketingSmsTemplateStore(this)
    this.marketingShortLinkStore = new MarketingShortLinkStore(this)
    this.marketingSmsManagementStore = new MarketingSmsManagementStore(this)
    this.marketingSmsManagementDetailsStore = new MarketingSmsManagementDetailsStore(this)
    this.emailAddressStore = new EmailAddressStore(this)
    this.emailTemplateStore = new EmailTemplateStore(this)
    this.emailListStore = new EmailListStore(this)
    this.marketingResourcePoolStore = new MarketingResourcePoolStore(this)
    this.miceCadStore = new MiceCadStore(this)
    this.fatigueConfigStore = new FatigueConfigStore(this)
    this.remarkTemplateListStore = new RemarkTemplateListStore(this)
    this.manualOutboundCallStore = new ManualOutboundCallStore(this)
    this.intelligentOutboundCallModelStore = new IntelligentOutboundCallModelStore(this)
    this.intelligentOutboundCallStore = new IntelligentOutboundCallStore(this)
    this.intelligentOutboundCallDetailsStore = new IntelligentOutboundCallDetailsStore(this)
    this.themeSettingStore = new ThemeSettingStore(this)
    this.intelligentQueryStore = new IntelligentQueryStore(this)
    this.reportTagStore = new ReportTagStore(this)
  }
}
